import React from "react";

import './LimitBar.css'

type LimitBarProps = {
    limiteDisponivel: number,
    limiteTotal: number
}

const LimitBar = ({ limiteDisponivel, limiteTotal }: LimitBarProps) => {

    const percentualDisponivel = limiteTotal > 0 ? (limiteDisponivel / limiteTotal) * 100 : 0;

    let innerStyle = {
        width: `100%`,
        height: `10px`,
    }

    // ? Estilo da parte da barra que representa o limite disponível
    let freeBarStyle = {
        width: `${percentualDisponivel}%`,
        height: `5px`,
        backgroundColor: '#55ff6c',
    }

    // ? Estilo da parte da barra que representa a parte ocupada do limite
    let busyBarStyle = {
        width: `${100 - percentualDisponivel}%`,
        height: `1px`,
        backgroundColor: 'white',
    }

    return (
        <div className="limit-bar-content"
            style={innerStyle}>
            <div className="limit-bar-busy" style={busyBarStyle}></div>
            <div className="limit-bar-free" style={freeBarStyle}></div>

            {/* <h6>{limiteDisponivel / limiteTotal}</h6> */}
        </div>
    );
}

export default LimitBar;